"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _richTextReactRenderer = require("@contentful/rich-text-react-renderer");

var _contentfulResolveResponse = _interopRequireDefault(require("contentful-resolve-response"));

// We need the original id from contentful as id attribute
// This code can be simplified as soon we properly replicate
// Contentful's sys object
const prepareIdsForResolving = obj => {
  for (let k in obj) {
    var _value$sys;

    const value = obj[k];

    if ((value === null || value === void 0 ? void 0 : (_value$sys = value.sys) === null || _value$sys === void 0 ? void 0 : _value$sys.type) === `Link` && value.sys.contentful_id) {
      value.sys.id = value.sys.contentful_id;
      delete value.sys.contentful_id;
    } else if (value && typeof value === `object`) {
      prepareIdsForResolving(value);
    }
  }
};

function renderRichText({
  raw,
  references
}, options = {}) {
  const richText = JSON.parse(raw); // If no references are given, there is no need to resolve them

  if (!references || !references.length) {
    return (0, _richTextReactRenderer.documentToReactComponents)(richText, options);
  }

  prepareIdsForResolving(richText); // Reconstruct the Contentful API response pattern to use the official
  // contentful-resolve-response module to resolve references

  const dummyResponse = {
    items: [{
      sys: {
        type: `Entry`
      },
      richText
    }],
    includes: {
      Entry: references.filter(({
        __typename
      }) => __typename !== `ContentfulAsset`).map(reference => {
        return { ...reference,
          sys: {
            type: `Entry`,
            id: reference.contentful_id
          }
        };
      }),
      Asset: references.filter(({
        __typename
      }) => __typename === `ContentfulAsset`).map(reference => {
        return { ...reference,
          sys: {
            type: `Asset`,
            id: reference.contentful_id
          }
        };
      })
    }
  };
  const resolved = (0, _contentfulResolveResponse.default)(dummyResponse, {
    removeUnresolved: true
  });
  return (0, _richTextReactRenderer.documentToReactComponents)(resolved[0].richText, options);
}

exports.renderRichText = renderRichText;